import { type components } from '@heidi/schema/ml-scribe';
import { useMutation } from '@tanstack/react-query';

import { CHECK_CURRENT_EMAIL } from '../../contracts/keys';
import { checkCurrentEmail } from '../api/email-change';

export type CheckCurrentEmailInput = components['schemas']['CheckCurrentEmailRequest'];
export type CheckCurrentEmailResponse =
  components['schemas']['CheckCurrentEmailResponse'];

export interface UseCheckCurrentEmailOptions {
  onError?: (error: unknown) => void;
}

export function useCheckCurrentEmail(options?: UseCheckCurrentEmailOptions) {
  return useMutation({
    mutationKey: [CHECK_CURRENT_EMAIL],
    mutationFn: async (data: CheckCurrentEmailInput) => {
      const response = await checkCurrentEmail(data);
      return response.data;
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
